import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl"
import { Link } from "react-router-dom";
import JoditReact from "jodit-react";
import "./Mail.css"
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import api from "../../../api";
import { toast } from "react-toastify";
const Mail = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [className,setClassName]=useState("")
    const [exam, setExam] = useState('');
    const [subject, setSubject] = useState('')
    const bodyContentRef = useRef(null);
    const [examId, setExamId] = useState('')
    const [exams, setExams] = useState([])
    const [emails, setEmails] = useState([])
    const [message, setMessage] = useState("")
    const [processing, setProcessing] = useState(false)
    const [examsLoading,setExamsLoading]=useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
          setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
      }, [message]);
    const editorConfig = {
        readonly: false,
        tabIndex: 1,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_clear_html",
        placeholder: "Type your description here ...",
        beautyHTML: true,
        toolbarButtonSize: "small",
        addNewLine: false,
        buttons: [
            "bold",
            "italic",
            'subscript',
            'superscript',
            "|",
            "ul",
            "ol",
            "link",
            "|",
            "font",
            "fontsize",
            "brush",
            "paragraph",
            "|",
            "table",
            "|",
            "left",
            "center",
            "right",
            "justify",
            "|",
            "undo",
            "redo",
            "|",
            "hr",
            "fullsize",
        ],
        extraButtons: [
            // {
            //     name: "image",
            //     tooltip: "Insert Image",
            //     exec: (editor) => {
            //         const input = document.createElement("input");
            //         input.type = "file";
            //         input.accept = "image/*";
            //         input.addEventListener("change", async (e) => {
            //             const file = e.target.files[0]; // Get the file from the input

            //             if (file) {
            //                 // Create FormData to send the file to the backend
            //                 const formData = new FormData();
            //                 formData.append("file", file); // Append the image file

            //                 try {
            //                     // Send the image to the backend server
            //                     const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
            //                         headers: {
            //                             "Content-Type": "multipart/form-data", // Ensure the correct content type
            //                         },
            //                     });

            //                     const imageUrl = response.data.url;

            //                     // Insert the uploaded image URL into the Jodit editor
            //                     editor.selection.insertImage(imageUrl);
            //                 } catch (err) {
            //                     console.error("Error uploading image:", err);
            //                 }
            //             }
            //         });
            //         input.click();
            //     },
            // },
        ],
        disablePlugins: ["speech"],
        toolbarAdaptive: false,
    }

    const handleBodyContent=(newContent)=>{
        if (bodyContentRef.current) {
            // Ensure that the ref is updated with new content, even when it's empty
            if (newContent === "") {
                bodyContentRef.current = "<p></p>"; // If the content is cleared, make sure the ref is set to an empty string
            } else {
                bodyContentRef.current = newContent; // Otherwise, set it to the new content
            }
          }
    }
    useEffect(() => {
        axios.get(`${baseUrl}/student/exam/exam-id?id=${examId}`)
            .then(res => {
                console.log(res);
                res.data.forEach((d, i) =>
                    setEmails(prev => prev.includes(d.email) ? prev : [...prev, d.email])
                )
            })
            .catch(err => { setEmails([]); console.log(err) })
    }, [examId])
    useEffect(()=>{
        setExams([])
        setExamsLoading(true)
        axios.get(`${baseUrl}/exam/all/by-class?className=${className}`)
        .then(res=>{setExams(res.data.data);setExamsLoading(false)})
        .catch(err=>{setExamsLoading(false)})
    },[className])
    const handleSubmit = (e) => {
        if(className===''){
            setMessage('Please Select class')
            return
        }
        if(exam===''){
            setMessage("Please Select Exam")
            return
        }
        if(subject===''){
            setMessage('Please enter subject')
            return
        }
        if(exam===''){
            setMessage('Please select exam')
            return
        }
        if (bodyContentRef.current === "<p><br></p>" || bodyContentRef.current === "<p></p>") {
            setMessage("Please Enter Message detail of mail")
            return
        }
        setProcessing(true)
        api.post(`${baseUrl}/exam/exam-mail`, { subject,emails,body:bodyContentRef.current })
            .then(res => {setMessage(res.data.message);setProcessing(false)})
            .catch(err => {
                toast.error(err?.response?.data?.message || "Something went wrong")
                setProcessing(false)})
        
    }

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
            <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Create Exam mail
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className={`container ${styles.container}`}>
                    <div className="bg-white p-4">
                    <h4>Create Exam mail</h4>
                        <div className="row mb-3">
                            <div className="col-lg-4">
                                <label htmlFor="subject" className="form-label">
                                    Subject
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="subject"
                                    placeholder="Enter mail subject"
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-4">
                                <label htmlFor="class" className="form-label">
                                    Class :
                                </label>
                                <select
                                    className="form-select"
                                    id="class"
                                    value={className}
                                    onChange={(e) => setClassName(e.target.value)}
                                    required
                                >
                                    <option value="" hidden>Select Class</option>
                                    <option>
                                        Class XI
                                    </option>
                                    <option>
                                        Class XII
                                    </option>
                                    <option>
                                        Class XII Passed
                                    </option>
                                </select>
                            </div>
                            <div className="col-lg-4">
                                <label htmlFor="examName" className="form-label">
                                    Exam Name
                                </label>
                                {
                                    examsLoading&&<p>Loading ....</p>
                                }
                                {
                                    className===''&&
                                    <p>Please select class</p>
                                }
                                {
                                    !examsLoading&&className!==''&&exams.length<1&&
                                    <p>No exam found for selected class</p>
                                }
                                {
                                    !className==''&&exams.length>0&&
                                    <select
                                        className="form-select"
                                        id="exam"
                                        value={examId}
                                        onChange={(e) => {
                                            const selectedOption = e.target.selectedOptions[0]; // Get the selected <option>
                                            setExam(selectedOption.title);
                                            setExamId(selectedOption.value);
                                        }}
                                        required
                                    >
                                        <option value="" hidden>Select Exam</option>
                                        {exams.map((c, index) => (
                                            <option key={index} value={c._id} title={c.examName}>
                                                {c.examName}
                                            </option>
                                        ))}
                                    </select>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="body" className="form-label">
                                    Detail
                                </label>
                                <JoditReact
                                    ref={bodyContentRef}
                                    config={editorConfig}
                                    onChange={handleBodyContent}
                                />
                            </div>
                        </div>
                        {
                            message &&
                            <div
                                className="alert alert-warning alert-dismissible fade show mt-3"
                                role="alert"
                            >
                                {message}
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="alert"
                                    aria-label="Close"
                                    onClick={() => setMessage(false)}
                                ></button>
                            </div>
                        }
                        <button disabled={processing} onClick={handleSubmit} className="btn btn-primary mt-4">
                            {processing ? 'Loading...' : 'Send'}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Mail;
